import { nucleusConstants } from '@lifesize/nucleus';

const actionLog = [
  nucleusConstants.MEDIA_DEVICES_UPDATED,
  nucleusConstants.CLOCK_TICK_MIN,
  nucleusConstants.CLOCK_TICK_SEC
];

const stateLog = [
  'nucleus.contacts.records',
  'nucleus.contactCRUD',
  'nucleus.dataWarehouse',
  'nucleus.phoneHD',
];

export default { stateLog, actionLog };



// WEBPACK FOOTER //
// ./src/constants/Filters.ts